export function animate(
  draw: (progress: number) => void,
  duration: number,
): {
  promise: Promise<void>;
  cancel: () => void;
} {
  const start = Date.now();
  let run = true;
  const cancel = () => (run = false);

  const promise = new Promise<void>((res) => {
    requestAnimationFrame(function frame() {
      const progress = (Date.now() - start) / duration;
      if (run) {
        if (progress >= 1) {
          draw(1);
          res();
        } else {
          draw(progress);
          requestAnimationFrame(frame);
        }
      }
    });
  });

  return { promise, cancel };
}

export function animateLinear(
  from: number,
  to: number,
  draw: (value: number) => void,
  duration: number,
): { promise: Promise<void>; cancel: () => void } {
  return animate((progress) => draw(from + (to - from) * progress), duration);
}
